import { 
    page, 
    report, 
    getAdSlotStat,
    getAdPublisherPosTrend,
    syncData 
} from '@/api/ad-pos-general.js'

export default {
  state: {
    list: [],
    pageNum: 1,
    pageSize: 10,
    total: 0,
    adPosGeneralLoading: false
  },
  mutations: {
    setList (state, list) {
      state.list = list
    },
    setAdPosGeneralLoading (state, loading) {
      state.adPosGeneralLoading = loading
    },
    setPageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setPageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setTotal (state, total) {
      state.total = total
    },
  },
  getters: {
    adPosGeneralList: state => state.list,
    adPosGeneralTotal: state => state.total,
    adPosGeneralLoading: state => state.adPosGeneralLoading
  },
  actions: {
    getAdPosGeneralReport ({ state, commit }, param) {
      return new Promise((resolve, reject) => {
        report(param).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getAdPosGeneralPage ({ state, commit }, param) {
      commit('setAdPosGeneralLoading', true)
      return new Promise((resolve, reject) => {
        page(param).then(res => {
          const data = res.data.result
          const list = data.records
          const total = data.total
          const pageNum = data.pageNum
          const pageSize = data.pageSize
          commit('setList', list)
          commit('setTotal', total)
          commit('setPageNum', pageNum)
          commit('setPageSize', pageSize)
          commit('setAdPosGeneralLoading', false)
          resolve()
        }).catch(err => {
          commit('setAdPosGeneralLoading', false)
          reject(err)
        })
      })
    },
    getAdPublisherPosTrend ({ state, commit }, param) {
      return new Promise((resolve, reject) => {
        getAdPublisherPosTrend(param).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getAdSlotStat ({ state, commit }, param) {
      return new Promise((resolve, reject) => {
        getAdSlotStat(param).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    syncAdPosData({ state, commit }) {
      return new Promise((resolve, reject) => {
        syncData().then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/module/ad-pos-general.js